import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=09fb4204&scoped=true&"
import script from "./BrandPage.vue?vue&type=script&lang=js&"
export * from "./BrandPage.vue?vue&type=script&lang=js&"
import style0 from "./BrandPage.vue?vue&type=style&index=0&id=09fb4204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb4204",
  null
  
)

export default component.exports